"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const card = require("./card");
/**Cabecera de una tabla estilizada */
class TableHeader extends React.Component {
    render() {
        return (React.createElement("tr", { className: "w3-indigo" }, this.props.children));
    }
}
exports.TableHeader = TableHeader;
/**Componente para un listado general de elementos. Ponga los elementos <tr /> de la tabla en los hijos del elemento*/
class Table extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    get items() {
        return this.props.items || this.props.children;
    }
    get TablaVacia() {
        const items = this.items;
        return !items || items.length == 0;
    }
    componentWillReceiveProps(props) {
        if (props.children) {
            console.warn("No mande los hijos de la tabla como hijos del elemento, utilice props.items");
        }
    }
    render() {
        const items = this.items;
        return (this.TablaVacia ?
            React.createElement(card.Card, { Header: "Lista vac\u00EDa" }, "No hay elementos que mostrar.") :
            React.createElement("div", { className: "table-responsive", style: { overflow: this.props.overflow ? "visible" : undefined } },
                React.createElement("table", { className: "table table-striped table-hover table-condensed" },
                    React.createElement("thead", null, this.props.header),
                    React.createElement("tbody", null, items))));
    }
}
exports.Table = Table;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/table.js
// module id = 134
// module chunks = 0